import CloseIcon from '../../../assets/icons/close.svg?react';
import { useState } from 'react';
import FileInput from '../../../components/FileInput';
import { useUpdateReportTemplate } from '../../../hooks/queries/reportQueries';

const ReportTemplateUpdateModal = ({ onClose, target, onUpdateSuccess }) => {
  const [isPending, setIsPending] = useState(false);
  const [formData, setFormData] = useState({
    templateName: target.TemplateName,
    templateVersion: target.Version,
    templateDescription: target.Description,
    templateHtmlFile: null,
    templateOtherFiles: null,
  });

  const updateReportTemplate = useUpdateReportTemplate();

  const handleChangeInput = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // HTML 파일 변경 시 호출 (단일 파일)
  const handleHtmlFileChange = (file) => {
    // file은 File 또는 null (multiple=false이므로 단일 파일)
    setFormData({ ...formData, templateHtmlFile: file });
  };

  // 그 외 파일 변경 시 호출 (multiple 모드에서는 File[] 또는 null)
  const handleOtherFilesChange = (files) => {
    // files는 File[] 또는 null
    setFormData({ ...formData, templateOtherFiles: files });
  };

  const handleUpdateReportTemplate = async () => {
    try {
      setIsPending(true);
      
      // HTML 파일과 그 외 파일들을 합쳐서 배열로 만듦
      const allFiles = [];
      if (formData.templateHtmlFile) {
        allFiles.push(formData.templateHtmlFile);
      }
      if (formData.templateOtherFiles && Array.isArray(formData.templateOtherFiles)) {
        allFiles.push(...formData.templateOtherFiles);
      }
      
      await updateReportTemplate.mutateAsync({
        reportTemplateSysId: target.ReportTemplateInfoSysId,
        templateName: formData.templateName,
        templateVersion: formData.templateVersion,
        templateDescription: formData.templateDescription,
        templateFiles: allFiles, // 합쳐진 File[] 배열
      });
      
      // 성공 시 폼 초기화
      setFormData({
        templateName: '',
        templateVersion: '',
        templateDescription: '',
        templateHtmlFile: null,
        templateOtherFiles: null,
      });
      
      onClose();
    } catch (error) {
      console.error('템플릿 추가 실패:', error);
      alert('템플릿 추가에 실패했습니다.');
    }
    finally {
      setIsPending(false);
    }
  };

  // 버튼 활성화 조건: HTML 파일은 필수
  const isFormValid = formData.templateName && 
                      formData.templateVersion && 
                      formData.templateDescription && 
                      formData.templateHtmlFile;
  
  return (
    <div className="side-modal-background">
      <div className="side-modal-container">
        <div className="side-modal-header">
          <h3>템플릿 수정</h3>
          <div className="side-modal-close" onClick={onClose}>
            <CloseIcon />
          </div>
        </div>
        <div className="side-modal-content">
          <table className='transparent-table w-full'>
            <tr>
              <td width="100px">
                <label htmlFor="templateName" className='w-20 mr-10 text-b2-700 required'>템플릿명</label>
              </td>
              <td>
                <input type="text" id="templateName" name="templateName" className='w-full input-primary' placeholder='템플릿명을 입력해주세요.' value={formData.templateName} onChange={handleChangeInput}/>
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="templateVersion" className='w-20 mr-10 text-b2-700 required'>버전</label>
              </td>
              <td>
                <input type="text" id="templateVersion" name="templateVersion" className='w-full input-primary' placeholder='버전을 입력해주세요.' value={formData.templateVersion} onChange={handleChangeInput}/>
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="templateDescription" className='w-20 mr-10 text-b2-700 required'>설명</label>
              </td>
              <td>
                <input type="text" id="templateDescription" name="templateDescription" className='w-full input-primary' placeholder='설명을 입력해주세요.' value={formData.templateDescription} onChange={handleChangeInput}/>
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="templateHtmlFile" className='w-20 text-b2-700 required'>HTML 파일</label>
              </td>
              <td>
                <div className="flex flex-col gap-4">
                  <FileInput 
                    value={formData.templateHtmlFile} 
                    onChange={handleHtmlFileChange}
                    multiple={false}
                    accept=".html,text/html"
                    placeholder="HTML 파일을 선택하세요 (필수, 1개)"
                  />
                  {!formData.templateHtmlFile && (
                    <span className="text-c2-400 text-red-500">HTML 파일은 필수입니다.</span>
                  )}
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="templateOtherFiles" className='w-20 text-b2-700'>추가 파일</label>
              </td>
              <td>
                <FileInput 
                  value={formData.templateOtherFiles} 
                  onChange={handleOtherFilesChange}
                  multiple={true}
                  placeholder="추가 파일을 선택하세요 (선택 사항, 다중 허용)"
                />
              </td>
            </tr>
          </table>
          <div className="mt-10">
            <button className="btn btn-primary big-btn w-full" onClick={handleUpdateReportTemplate} disabled={isPending || !isFormValid}>{isPending ? '수정중...' : '수정'}</button>
          </div>
          {updateReportTemplate.error && (
            <div className="mt-10 text-red-500 text-c2-400">
              템플릿 수정에 실패했습니다.
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ReportTemplateUpdateModal